import { MsalProvider } from '@azure/msal-react';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import './app/styles/global.css';
import { msalInstance, msalInitPromise } from '@/app/modules/auth/authConfig';
import { Notistack } from './app/shared/components/Notistack';
import { NotistackProvider } from './app/shared/components/NotistackProvider';
import { AnalyticsProvider } from './app/shared/context/AnalayticsProvider';
import { router } from './app/shared/routes/routes';
import { muiTheme } from './app/styles/muiTheme';
import { persistor, store } from './store';
import './assets/scss/main.scss';

LicenseInfo.setLicenseKey(import.meta.env.REACT_APP_MUI_LICENSE_KEY);

// Initialize MSAL and handle redirect promise before rendering
msalInitPromise
  .then(() => {
    // Handle redirect from login - this processes the auth response from Azure B2C
    return msalInstance.handleRedirectPromise().then((response) => {
      const redirectPath = sessionStorage.getItem('postLoginRedirect');

      if (redirectPath) {
        sessionStorage.removeItem('postLoginRedirect');

        window.location.replace(redirectPath);
      } else if (response?.state) {
        window.location.replace(response.state);
      }
    });;
  })
  .then(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <NotistackProvider>
          <MsalProvider instance={msalInstance}>
            <MuiThemeProvider theme={muiTheme}>
              <CssBaseline />
              <Provider store={store}>
                <AnalyticsProvider>
                  <PersistGate
                    loading={null}
                    persistor={persistor}
                  >
                    <RouterProvider router={router} />
                  </PersistGate>
                </AnalyticsProvider>
              </Provider>
            </MuiThemeProvider>
          </MsalProvider>
          <Notistack />
        </NotistackProvider>
      </StrictMode>
    );
  })
  .catch((error) => {
    console.error('MSAL initialization or redirect handling failed:', error);
  });
